<template>
  <div class="hostory-content-wrapper">
    <proa-avatar
      size="sm"
      :src="taskCardHistory.editor ? taskCardHistory.editor.meta.avatar || require('@/assets/images/avatar_default.png') : require('@/assets/images/avatar_default.png')"
      :class="['editor-avatar', { 'deleted': !taskCardHistory.editor }]"
      @click.native="setMemberModalId(taskCardHistory.editor.id)"
    />
    <div class="history-body">
      <div>
        <span v-if="taskCardHistory.editor" class="editor-display-name">
          {{ taskCardHistory.editor.meta.displayName }}
        </span>
        <span v-else class="editor-display-name deleted">{{ $t('common.deletedMember') }}</span>
        <span class="history-created-at">
          {{ taskCardHistory.createdAt | moment('YYYY/MM/DD HH:mm') }}
        </span>
      </div>
      <div v-if="taskCardHistory.isFirst" class="history-content">
        <div class="created mb-2">{{ $t('models.taskCardHistory.created') }}</div>
        <div v-for="attribute in taskCardHistory.createdAttributes" :key="attribute.key" class="mb-1">
          <div class="font-weight-w6">{{ $t(`models.taskCardHistory.attributes.${attribute.key}`) }}</div>
          <div class="pl-1">
            <span v-if="['startAt', 'endAt'].includes(attribute.key)">{{ attribute.value | moment('YYYY年MM月DD日（ddd）') }}</span>
            <span v-else-if="attribute.key === 'progress'">{{ attribute.value }}%</span>
            <span v-else-if="attribute.key === 'projectLabelIds'">
              <proa-project-label
                v-for="projectLabel in projectLabelsByIds(attribute.value)"
                :key="projectLabel.id"
                :title="projectLabel.title"
                :color="projectLabel.color"
                class="mr-2"
              />
            </span>
            <span v-else-if="attribute.key === 'taskListId'" :class="{ 'deleted': !taskListTitleById(attribute.value) }">
              {{ taskListTitleById(attribute.value) || $t('models.taskCardHistory.deletedTaskList') }}
            </span>
            <span v-else-if="attribute.key === 'userIds'">
              {{ taskCardMemberDisplayNamesByIds(attribute.value) }}
            </span>
            <span v-else>{{ attribute.value }}</span>
          </div>
        </div>
      </div>
      <div v-else class="history-content">
        <div v-for="attribute in taskCardHistory.changedAttributes" :key="attribute.key" class="mb-1">
          <div>
            <span class="font-weight-w6">{{ $t(`models.taskCardHistory.attributes.${attribute.key}`) }}</span>
            <span>{{ $t('common.hasChanged') }}</span>
          </div>
          <div class="pl-1">
            <span v-if="['startAt', 'endAt'].includes(attribute.key)">{{ attribute.value | moment('YYYY年MM月DD日（ddd）') }}</span>
            <span v-else-if="attribute.key === 'progress'">{{ attribute.value }}%</span>
            <span v-else-if="attribute.key === 'projectLabelIds'">
              <proa-project-label
                v-for="projectLabel in projectLabelsByIds(attribute.value)"
                :key="projectLabel.id"
                :title="projectLabel.title"
                :color="projectLabel.color"
                class="mr-2"
              />
            </span>
            <span v-else-if="attribute.key === 'taskListId'" :class="{ 'deleted': !taskListTitleById(attribute.value) }">
              {{ taskListTitleById(attribute.value) || $t('models.taskCardHistory.deletedTaskList') }}
            </span>
            <span v-else-if="attribute.key === 'userIds'">
              {{ taskCardMemberDisplayNamesByIds(attribute.value) }}
            </span>
            <span v-else>{{ attribute.value }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import TaskList from '@/store/models/TaskList'
import User from '@/store/models/User'

export default {
  name: 'TaskCardHistoryContent',
  props: {
    taskCardHistory: Object,
    projectLabels: Array
  },
  computed: {
    projectLabelsByIds: function() {
      return function(projectLabelIds) {
        return this.projectLabels.filter((projectLabel) => {
          return projectLabelIds.includes(projectLabel.id)
        })
      }
    },
    taskCardMemberDisplayNamesByIds: function() {
      return function(userIds) {
        return User.findIn(userIds).map((user) => {
          return user.meta.displayName
        }).join(', ')
      }
    },
    taskListTitleById: function() {
      return function(taskListId) {
        return TaskList.find(taskListId)?.title
      }
    }
  },
  methods: {
    ...mapMutations({
      setMemberModalId: 'setMemberModalId'
    })
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.hostory-content-wrapper {
  display: flex;
  align-items: flex-start;

  .editor-avatar:not(.deleted) {
    cursor: pointer;
  }

  .history-body {
    flex-grow: 1;
    margin: 0 20px 0 10px;

    @include mq(md) {
      margin: 0;
    }

    .editor-display-name {
      font-size: 14px;
      font-weight: 600;
      margin: 0;

      @include mq(md) {
        margin: 0 15px 10px 10px;
      }

      &.deleted {
        color: $light-text-color;
      }
    }

    .history-created-at {
      font-size: 12px;
      color: $light-text-color;
    }

    .history-content {
      margin: 10px 0 0 0;
      white-space: pre-wrap;
      word-break: break-all;

      @include mq(md) {
        margin: 10px 20px 0 10px;
      }

      .created, .deleted {
        color: $light-text-color;
      }
    }
  }
}
</style>
